export default __webpack_public_path__ + "static/media/2412307.465b5fd7.webp";